<template>
  <el-dialog custom-class="converter-select-container dialog-size-middle"
             title="変換方法の選択"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="converter-select-container-inner">
      <el-menu class="converter-select-navi-container" mode="vertical" :unique-opened="true"
               :default-active="selectedConverter ? selectedConverter.id : ''">
        <el-submenu v-for="converterCategory in convertersCategories" :index="converterCategory.categoryId">
          <template slot="title">
            <span slot="title">{{ converterCategory.label }}</span>
          </template>
          <el-menu-item :index="converterSummary.id" v-for="converterSummary in converterCategory.data"
                        @click="onClickMenuItem(converterSummary)">
            <span slot="title">{{ converterSummary.name }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
      <div class="converter-select-main-container">
        <h2>{{selectedConverter ? selectedConverter.name : ''}}</h2>
        <p v-html="selectedConverter ? $options.filters.html_format(getConverterTip(selectedConverter.id)) : ''"></p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickSelect">OK</el-button>
    </span>
  </el-dialog>
</template>

<script lang="js">
import { ConverterSummary, ConverterTip } from '../../../defines/convert'

export default {
  name: 'ConverterSelectDialogCmp',
  props: {
    convertersCategories: Array,
    selectedConverterForInit: ConverterSummary
  },
  data () {
    return {
      selectedConverter: this.selectedConverterForInit,
      visible: true
    }
  },
  methods: {
    onClickMenuItem (converterSummary) {
      this.selectedConverter = converterSummary
      this.$forceUpdate()
    },
    onClickSelect () {
      this.visible = false
      this.$emit('select', this.selectedConverter)
    },
    getConverterTip (converterId) {
      return ConverterTip[converterId]
    }
  }
}

</script>

<style type="scss" scoped>
  .converter-select-container-inner {
    display: flex;
    flex-direction: row;
    height: 475px;
  }

  .converter-select-container-inner > .converter-select-navi-container {
    flex-shrink: 0;
    width: 330px;
    overflow-y: scroll;
  }

  .converter-select-container-inner > .converter-select-main-container {
    flex-shrink: 0;
    flex-grow: 1;
    padding-left: 24px;
    max-width: 630px;
  }

  .converter-select-container-inner > .converter-select-main-container > h2 {
    margin: 0;
  }

  .converter-select-container-inner > .converter-select-main-container > p {
    margin-top: 0;
    word-wrap: break-word;
  }

  .converter-select-container-inner > .converter-select-main-container > .converter-select-main-img-container {
    text-align: center;
    padding: 16px 0;
  }

  .converter-select-container-inner > .converter-select-main-container > .converter-select-main-img-container > img {
    width: 480px;
  }
</style>



// WEBPACK FOOTER //
// src/components/data-convert/dialogs/converter-select.vue